export default __webpack_public_path__ + "static/media/gebco_bathy.5400x2700_8bit.877f85fd.jpg";